import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

const signals = [
  { label: 'Emotion match', value: 92, color: '#c7ff4a' },
  { label: 'Interest affinity', value: 84, color: '#8b7cff' },
  { label: 'Safety', value: 97, color: '#48e8c7' }
];

const LandingPage = () => (
  <main className="landing-page">
    <div className="ambient ambient-one" aria-hidden="true" />
    <div className="ambient ambient-two" aria-hidden="true" />

    <header className="landing-nav shell">
      <Link className="wordmark" to="/" aria-label="Lori home">
        <span className="wordmark-mark"><img src="/lori-mark.png" alt="" /></span>
        <span>Lori</span>
      </Link>
      <nav aria-label="Main navigation">
        <a href="#system">System</a>
        <a href="#principles">Principles</a>
        <Link className="nav-demo" to="/dashboard">Open live demo <span>↗</span></Link>
      </nav>
    </header>

    <section className="hero shell">
      <div className="hero-copy">
        <div className="status-pill"><span /> Public product preview</div>
        <h1>A feed that doesn't<br /><em>consume you.</em></h1>
        <p className="hero-lead">
          Lori brings emotion, context and safety signals together in one transparent social discovery system.
        </p>
        <div className="hero-actions">
          <Link className="primary-action" to="/experience">Explore the experience <span>→</span></Link>
          <Link className="text-action" to="/algorithm">How does the algorithm work?</Link>
        </div>
        <p className="hero-note">No account. No sign-up. The same demo for everyone.</p>
      </div>

      <div className="signal-stage" aria-label="Lori algorithm signal preview">
        <div className="orbit orbit-a" />
        <div className="orbit orbit-b" />
        <div className="signal-card glass-card">
          <div className="card-topline"><span>LIVE RANKING</span><i /></div>
          <div className="content-preview">
            <div className="preview-avatar">N</div>
            <div><strong>A new point of view</strong><small>Science · 4 min read</small></div>
            <b>#01</b>
          </div>
          <div className="signal-list">
            {signals.map((signal) => (
              <div className="signal-row" key={signal.label}>
                <div><span>{signal.label}</span><strong>{signal.value}%</strong></div>
                <div className="signal-track"><i style={{ width: `${signal.value}%`, background: signal.color }} /></div>
              </div>
            ))}
          </div>
          <div className="score-line"><span>FINAL SCORE</span><strong>0.91</strong></div>
        </div>
        <div className="float-label float-label-one"><span>↗</span> Less noise</div>
        <div className="float-label float-label-two"><span>◎</span> Explainable results</div>
      </div>
    </section>

    <section className="manifesto shell" id="system">
      <p className="section-kicker">AN ALGORITHM YOU CAN SEE</p>
      <h2>Every decision comes<br />with a reason you can read.</h2>
      <div className="flow-grid">
        {[
          ['01', 'Understand the signal', 'Live emotion, energy and interest signals become an eight-dimensional context.'],
          ['02', 'Match the content', 'Quality, topic affinity and diversity are evaluated together.'],
          ['03', 'Rank with care', 'Risky content is slowed down; every result explains why it appeared.']
        ].map(([number, title, copy]) => (
          <article className="flow-card" key={number}>
            <span>{number}</span><div className="flow-icon" aria-hidden="true" />
            <h3>{title}</h3><p>{copy}</p>
          </article>
        ))}
      </div>
    </section>

    <section className="principles shell" id="principles">
      <div>
        <p className="section-kicker">DESIGN PRINCIPLE</p>
        <h2>Technology that protects<br />your rhythm, not drains it.</h2>
      </div>
      <div className="principle-list">
        <p><span>01</span> No endless-scroll pressure</p>
        <p><span>02</span> No hidden ranking signals</p>
        <p><span>03</span> Automatic reach limits for risky content</p>
      </div>
    </section>

    <section className="final-cta shell">
      <div className="cta-orb" aria-hidden="true" />
      <p>THE PREVIEW IS READY</p>
      <h2>Step inside Lori's<br />decision engine.</h2>
      <Link className="primary-action light" to="/dashboard">Enter the demo <span>→</span></Link>
    </section>

    <footer className="landing-footer shell">
      <Link className="wordmark" to="/"><span className="wordmark-mark"><img src="/lori-mark.png" alt="" /></span><span>Lori</span></Link>
      <p>Human-first social discovery prototype · 2026</p>
    </footer>
  </main>
);

export default LandingPage;
